import { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import enviroment from '../../../enviroments/enviroment';
import { AppContext } from '../../../commons/context/App-context';
import Recaptcha from '../../../commons/components/recaptcha/Recaptcha';
import {
    EEmail,
    EErrorMsg,
    ESuccessMsg,
} from '../../../commons/statics/controls';
import './forgot-password.scss';

interface IForgotPassword {
    email: string;
}

const ForgotPassword = () => {
    const { register, handleSubmit, formState } = useForm({
        mode: 'onChange',
    });
    const { errors, isDirty, isValid } = formState;
    const { isLoading, changeIsLoading } = useContext(AppContext);
    const [msgError, setMsgError] = useState<string>('');
    const [mailSend, setMailSend] = useState<boolean>(false);

    const handleOnSubmit = (u: IForgotPassword) => {
        const { email } = u;
        changeIsLoading(true);
        setMailSend(false);
        setMsgError('');
        if (email) {
            axios
                .post(enviroment.apiURL + '/user/password_recovery', {
                    email,
                })
                .then((res: any) => {
                    const { err } = res?.data || {};

                    changeIsLoading(false);
                    if (err) {
                        setMsgError(err);
                    } else {
                        setMailSend(true);
                    }
                })
                .catch(() => {
                    changeIsLoading(false);
                    setMsgError(EErrorMsg.generic);
                });
        } else {
            changeIsLoading(false);
            setMsgError(EErrorMsg.dataForm);
        }
    };

    const handleBackLanding = () => {
        window.open('https://rpp.pe/empresasquetransforman', '_self');
    };

    return (
        <Recaptcha>
            <div className="ForgotPasswordWrapFull">
                <div className="ForgotPasswordLogo">
                    <img
                        alt="Empresas que transforman el Perú"
                        src="/images/logo.png"
                        onClick={handleBackLanding}
                    />
                </div>
                <div className="ForgotPasswordWrap">
                    <div className="ForgotPasswordWrapInner">
                        <h4 className="ForgotPasswordTitle">
                            ¿Olvidaste tu contraseña?
                        </h4>
                        <p className="mb2">
                            Ingresa el correo electrónico con el que te
                            registraste.
                        </p>
                        {mailSend && (
                            <div className="mb1 helpText valid">
                                {ESuccessMsg.mailSend}
                            </div>
                        )}
                        <form
                            onSubmit={handleSubmit(handleOnSubmit)}
                            className="ForgotPasswordWrapForm"
                        >
                            <div className="mb1">
                                <label
                                    className={classnames({
                                        label: true,
                                        invalid: errors?.email,
                                    })}
                                    htmlFor="email"
                                >
                                    Correo electrónico
                                </label>
                                <input
                                    className={classnames({
                                        input: true,
                                        invalid: errors?.email,
                                    })}
                                    id="email"
                                    type="text"
                                    placeholder="Ingresa tu Mail corporativo"
                                    maxLength={EEmail.maxLength}
                                    disabled={mailSend}
                                    {...register('email', {
                                        required: {
                                            value: true,
                                            message: 'Email es requerido.',
                                        },
                                        pattern: {
                                            value: EEmail.pattern,
                                            message:
                                                'Ingresa un Mail corporativo válido.',
                                        },
                                        minLength: {
                                            value: EEmail.minLength,
                                            message:
                                                'Min. ' +
                                                EEmail.minLength +
                                                ' caracteres.',
                                        },
                                        maxLength: {
                                            value: EEmail.maxLength,
                                            message:
                                                'Max. ' +
                                                EEmail.maxLength +
                                                ' caracteres.',
                                        },
                                    })}
                                />
                                <div className="helpText invalid">
                                    {errors?.email && errors?.email?.message}
                                </div>
                            </div>
                            <div className="mb1">
                                <button
                                    className="button buttonFull"
                                    type="submit"
                                    disabled={
                                        mailSend ||
                                        isLoading ||
                                        !isDirty ||
                                        !isValid
                                    }
                                >
                                    Enviar
                                </button>
                            </div>
                            <p className="small">
                                Recuerda revisar tu bandeja de correo no deseado
                                y agregar &nbsp;
                                <a href="mailto:empresasquetransforman@rpp.com.pe">
                                    empresasquetransforman@rpp.com.pe
                                </a>
                                &nbsp; a tu lista de remitentes seguros.
                            </p>
                            {msgError && (
                                <div className="mb1 helpText invalid">
                                    {msgError}
                                </div>
                            )}
                        </form>
                        <Link
                            className="button buttonText buttonAuto buttonTextUnderline"
                            to="/signin"
                        >
                            Volver
                        </Link>
                    </div>
                </div>
            </div>
        </Recaptcha>
    );
};

export default ForgotPassword;
